// extracted by mini-css-extract-plugin
export default {"rectangle":"styles_rectangle__XqfZO","pending":"styles_pending__+gJnp","completed":"styles_completed__tDdUL","rejected":"styles_rejected__vPYZ6"};